export function makeToast(el: HTMLElement): (msg: string, ms?: number) => void {
  let timer = 0;
  return (msg, ms) => {
    el.textContent = msg;
    el.style.display = 'block';
    if (timer) clearTimeout(timer);
    timer = window.setTimeout(() => { el.style.display = 'none'; }, ms || 2600);
  };
}
